import { render, staticRenderFns } from "./cCard.vue?vue&type=template&id=107ab4ca&scoped=true"
import script from "./cCard.vue?vue&type=script&lang=js"
export * from "./cCard.vue?vue&type=script&lang=js"
import style0 from "./cCard.vue?vue&type=style&index=0&id=107ab4ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ab4ca",
  null
  
)

export default component.exports